export enum ToggleWidget {
  Expand = 'Expand',
  Collapse = 'Collapse',
}
